export default {
  APP: undefined,
  SHOWING_HAND_TUTO: false,
};
